import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  title: [
    {...makeRule('请输入教程标题', 'string')},
  ],
  content: [
    {...makeRule('请输入教程正文', 'string')},
  ],
  video_url: [
    {...makeRule('请上传教程简介', 'string')},
  ],
  description: [
    {...makeRule('请输入教程简介', 'string')},
  ],
  image_url: [
    {...makeRule('请上传封面', 'string')},
  ],
  level: [
    {...makeRule('请输入优先级', 'integer')},
  ],
  badge_start: [
    {...makeRule('请选择角标开始时间', 'string')},
  ],
  badge_end: [
    {...makeRule('请选择角标结束时间', 'integer')},
  ],
}

export let marketFormRules = {
  marketname: [
    {...makeRule('请输入门店名称', 'string')},
  ],
  address: [
    {...makeRule('请输入地址', 'string')},
  ],
  provinceid: [
    {...makeRule('请选择省份', 'integer')},
  ],
  cityid: [
    {...makeRule('请选择城市', 'integer')},
  ],
  areaid: [
    {...makeRule('请选择地区', 'integer')},
  ],
  longitude: [
    {...makeRule('请输入百度经度', 'number')},
  ],
  latitude: [
    {...makeRule('请输入百度纬度', 'number')},
  ],
  lon_gd: [
    {...makeRule('请输入高德经度', 'number')},
  ],
  lat_gd: [
    {...makeRule('请输入高德纬度', 'number')},
  ],
}



// WEBPACK FOOTER //
// ./src/views/platform/platform.rules.js